import { schema } from 'normalizr';

export const product = new schema.Entity(
  'products',
  {},
  {
    idAttribute: ({ vendorId }) => vendorId,
    mergeStrategy: (entityA, entityB) => ({
      ...entityA,
      ...entityB,
    }),
    processStrategy: ({ productName, vendorId }) => ({
      id: parseInt(vendorId, 10) || vendorId,
      productName,
      vendorId: parseInt(vendorId, 10) || vendorId,
    }),
  }
);

export const products = [product];
